import {GuideFormFields} from "../../../../types/formFieldTypes";

export const guideValidate = (values: GuideFormFields) => {
    const errors = {} as { [key: string]: string }
    if (!values.name) errors.name = 'Введите название'
    if (!values.text) errors.description = 'Введите текст'
    return errors
}

export const initialGuideFields = {
    name: '',
    path: '',
    text: '',
    number: 0,
}

export const clearGuideErrors = {
    name: '',
    path: '',
    text: ''
}